import { Container } from "react-bootstrap";

const AvisoLegal = () => {
    return (
        <Container className="my-5">
            <h1>Aviso Legal</h1>

            <section className="mt-4">
                <h4>1. INFORMACIÓN LEGAL</h4>
                <p>
                    De acuerdo con lo estipulado en el artículo 10 de la Ley 34/2002, del 11 de julio, relativa a los Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE), proporciono a los usuarios y autoridades competentes la siguiente información:
                </p>
                <ul className="list-unstyled text-start" style={{ paddingLeft: 0 }}>
                    <li style={{ textAlign: "left" }}><strong>Nombre / Razón social:</strong> Matias Alessandro Contreras</li>
                    <li style={{ textAlign: "left" }}><strong>NIF:</strong> X3829511B</li>
                    <li style={{ textAlign: "left" }}><strong>Domicilio social:</strong> Calle Asarau 20 1º B, 12001 Castellón</li>
                    <li style={{ textAlign: "left" }}><strong>Correo electrónico:</strong> No disponible</li>
                    <li style={{ textAlign: "left" }}><strong>Teléfono:</strong> 621 06 10 16</li>
                    <li style={{ textAlign: "left" }}><strong>Nombre de dominio:</strong> manusfortis.es</li>
                    <li style={{ textAlign: "left" }}><strong>Actividad:</strong> Centro de masajes</li>
                </ul>
            </section>

            <section className="mt-4">
                <h4>2. CONDICIONES GENERALES DE USO</h4>
                <p>
                    El acceso a este sitio web se ofrece de manera libre y gratuita. Cualquier usuario que navegue por este sitio acepta implícitamente las condiciones de uso descritas en este Aviso Legal.
                </p>
                <p>
                    Me reservo el derecho de modificar este Aviso Legal sin previo aviso, por lo que se recomienda revisarlo periódicamente.
                </p>
                <p>
                    Todos los usuarios se comprometen a utilizar el sitio de buena fe, respetando la ley y evitando introducir contenidos injuriosos o maliciosos. Asimismo, se abstendrán de bloquear o dañar las funcionalidades, contenidos o infraestructura del sitio.
                </p>
            </section>

            <section className="mt-4">
                <h4>3. PROPIEDAD INTELECTUAL</h4>
                <p>
                    Todos los elementos del sitio, incluyendo textos, imágenes, fotografías, animaciones y diseños, están protegidos por derechos de propiedad intelectual. No se permite su reproducción, distribución o modificación sin autorización previa y por escrito.
                </p>
                <p>
                    El material presente en este sitio web se permite únicamente para uso personal y privado. Queda prohibido su uso con fines comerciales o ilícitos. Todos los derechos están expresamente reservados.
                </p>
            </section>

            <section className="mt-4">
                <h4>4. COMPROMISOS CON EL USUARIO</h4>
                <p>
                    Me comprometo a no realizar publicidad engañosa y a corregir cualquier error en el contenido tan pronto como tenga conocimiento del mismo. Asimismo, no se enviarán comunicaciones comerciales sin identificarlas como tales y sin consentimiento previo, salvo información relacionada con servicios contratados por los clientes.
                </p>
            </section>

            <section className="mt-4">
                <h4>5. PROTECCIÓN DE DATOS PERSONALES</h4>
                <p>
                    Me comprometo a tratar los datos personales de acuerdo con el Reglamento General de Protección de Datos (RGPD 2016/679) y la Ley Orgánica 3/2018 de Protección de Datos Personales y garantía de los derechos digitales (LOPDPGDD). Para más información, consulte la Política de Privacidad.
                </p>
            </section>

            <section className="mt-4">
                <h4>6. INCUMPLIMIENTOS Y RESPONSABILIDADES</h4>
                <p>
                    No me hago responsable del uso indebido que terceros puedan hacer de los contenidos, enlaces o información del sitio web. Cualquier incumplimiento de la normativa por parte del usuario es responsabilidad exclusiva del mismo.
                </p>
            </section>

            <section className="mt-4">
                <h4>7. LEGISLACIÓN APLICABLE Y FUERO JURISDICCIONAL</h4>
                <p>
                    La legislación aplicable es la española. Los juzgados y tribunales competentes para resolver cualquier conflicto derivado del uso de este sitio web serán los correspondientes a mi domicilio social.
                </p>
            </section>
        </Container>
    );
};

export default AvisoLegal;
